import { jsx } from "panel";
import { TooltipEl } from "common/components/tooltip";
import { ButtonEl } from "common/components/button";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { instrumentWithTimer } from "common/util/workflow-timing";
export function template() {
  const {
    contextPanelTransform
  } = this.params;
  const {
    print
  } = this.getContext("i18n");
  return /* @__PURE__ */ jsx("div", { sel: ".mp-control-bar", attrs: {
    elref: "menuItems"
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, (() => {
    const overflowItems = this.getOverflowItems();
    const controls = this.params.controls;
    return /* @__PURE__ */ jsx(null, null, controls === null || controls === void 0 ? void 0 : controls.items.map((section, index) => {
      const {
        isDisabled,
        icon,
        highlightIcon,
        label,
        theme,
        value,
        slot,
        tooltip,
        elref
      } = section;
      return /* @__PURE__ */ jsx("div", { sel: ".mp-control-bar-control" }, tooltip && /* @__PURE__ */ jsx(TooltipEl, { attrs: tooltip }), slot ? /* @__PURE__ */ jsx("slot", { attrs: {
        name: slot
      } }) : /* @__PURE__ */ jsx(ButtonEl, { key: "".concat(index, "-value"), attrs: {
        disabled: isDisabled,
        icon,
        "highlight-icon": highlightIcon,
        value,
        theme: theme || this.params.theme,
        elref
      }, on: {
        click: instrumentWithTimer(this.handleClick)
      } }, label ? print(label) : null));
    }), overflowItems.length ? /* @__PURE__ */ jsx("div", { sel: ".mp-control-bar-truncated-menu-container" }, /* @__PURE__ */ jsx(SelectEl, { attrs: {
      theme: SelectTheme.Tertiary,
      size: this.params.size,
      "show-preview-tooltip": !this.params.overflowTooltip,
      tooltip: this.params.overflowTooltip,
      icon: {
        leftIcon: this.params.overflowIcon
      },
      "icon-only": true,
      "menu-width": this.params.overflowMenuWidth,
      "menu-height": this.params.overflowMenuHeight,
      "menu-alignment": this.params.overflowMenuAlignment,
      elref: "overflowMenu",
      disabled: this.params.disabled,
      "disable-tooltip": this.params.disableTooltip
    }, on: {
      change: this.handleMenuClick,
      menuChange: this.handleMenuChange
    }, props: {
      contextPanelTransform,
      sections: overflowItems
    } })) : null);
  })());
}
